import { AxiosError } from 'axios';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';

import axios from './axios';

export interface UseUploadUsersListVariables {
  is_licensed: boolean;
  is_admin: boolean;
  file: any;
}

export interface UseUploadUsersListData {}

export function useUploadUsersList() {
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation<
    UseUploadUsersListData,
    AxiosError<UseUploadUsersListData>,
    UseUploadUsersListVariables
  >(
    (variables) => {
      var formData = new FormData();

      formData.append('is_licensed', variables.is_licensed.toString());
      formData.append('is_admin', variables.is_admin.toString());
      formData.append('users', variables.file);

      return axios
        .post<UseUploadUsersListData>('/posht/ashena/users/import/', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((res) => res.data);
    },
    {
      onError: () => {
        enqueueSnackbar(t('errors.unknown'), { variant: 'error' });
      },
      onSuccess: () => {
        enqueueSnackbar(t('operation.successful'), { variant: 'success' });
      },
    },
  );
}
